import { ButtonV2, Flex, styled } from '@withjoy/joykit';

export const FormContainer = styled(Flex)`
  max-width: 500px;
  margin: 2rem;

  border-radius: 20px;
  box-shadow: rgba(0, 0, 0, 0.07) 0px 4px 16px 0px, rgba(44, 41, 37, 0.06) 0px 7px 27px 0px;

  gap: 1.75rem;
  flex-direction: column;

  padding: 56px 26px 56px 26px;
`;

export const SubmitButton = styled(ButtonV2)`
  border-radius: 64px;
  height: 4rem;
  margin-top: 2rem;
`;

export const CenteredFields = styled(Flex)`
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const FormHeader = styled(Flex)`
  width: 100%;
  flex-direction: column;
  gap: 0.25rem;
  justify-content: center;
  text-align: center;

  margin-bottom: 0.5rem;
`;
